/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseAutoTestQualityComment } from './BaseAutoTestQualityComment';
const AutoTestQualityCommentParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['stepId', codecNumber, 'step_id'],
    ['resultId', codecNumber, 'result_id'],
    ['fileId', codecString, 'file_id'],
]), BaseAutoTestQualityComment);
export class AutoTestQualityComment extends BaseAutoTestQualityComment {
    static decode(input) {
        return AutoTestQualityCommentParser.decode(input).map(res => new AutoTestQualityComment(res));
    }
    static unsafeDecode(input) {
        return AutoTestQualityComment.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestQualityCommentParser.encode(data);
    }
    static schema() {
        return AutoTestQualityCommentParser.schema();
    }
}
